import React, {useState, useEffect, useContext, useRef} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import EntitiesList from './EntitiesList';
import EntityView from './EntityView';
import {EntityContext} from 'contexts/EntityContext';
import {ErrorContext} from 'contexts/ErrorContext';
import {getEntities, checkStatus} from 'utils/api/entitiesApi';
import {getRandomColor} from 'utils/other';
import Loader from 'components/Loader';
import {connect} from 'react-redux';
import './style.scss';

const Entities = ({auth}) => {
    let {activeIdFromUrl} = useParams();
    let history = useHistory();

    let {handleErrors} = useContext(ErrorContext);
    let {activeEntity, setActiveEntity, pendingEntities, setPendingEntities} = useContext(EntityContext);

    const [entitiesLoading, setEntitiesLoading] = useState(true);
    const [fullEntitiesList, setFullEntitiesList] = useState([]);
    const [entityNews, setEntityNews] = useState([]);
    const [activeView, setActiveView] = useState('entities');
    const [initialEntityCheck, setInitialEntityCheck] = useState(true);
    const [urlEntityScrolledTo, setUrlEntityScrolledTo] = useState(false);
    const scrollRef = useRef(null);

    useEffect(() => {
        fetchEntities();
    }, []);

    useEffect(() => {
        if(activeEntity && !entitiesLoading && !urlEntityScrolledTo) {
            let foundEntity = fullEntitiesList.find(item => item.id === activeEntity.id);
            if(foundEntity) {
                let index = fullEntitiesList.indexOf(foundEntity);
                scrollRef.current && scrollRef.current.scrollToItem(index);
                setUrlEntityScrolledTo(true);
            }
        }
    }, [fullEntitiesList, entitiesLoading, activeEntity]);

    useEffect(() => {
        let pendingArr = fullEntitiesList.filter(ent => {
            return ent.status <= 1;
        })
        setPendingEntities(pendingArr.map(item => item.id));
    }, [fullEntitiesList])

    useEffect(() => {
        let statusInterval;
        if(activeEntity) {
            statusInterval = setInterval(() => {
                checkEntityStatus(activeEntity ? activeEntity.status : null);
            }, 7000);
            if(pendingEntities.length === 0) {
                clearInterval(statusInterval)
            }
        } else {
            clearInterval(statusInterval)
        }

        return () => clearInterval(statusInterval);
    }, [pendingEntities, activeEntity])

    const checkEntityStatus = async(activeStatus) => {
        try {
            let statusData = await checkStatus(pendingEntities);
            let foundEntityInResponse = statusData.content.find(obj => obj.id === activeEntity.id);
            if(foundEntityInResponse && foundEntityInResponse.status !== activeEntity.status) {
                if(foundEntityInResponse.status > 1) {
                    let contextEntityClone = [...pendingEntities];
                    let index = contextEntityClone.indexOf(contextEntityClone.find(item => item.id === foundEntityInResponse.id));
                    index && contextEntityClone.splice(index, 1);
                    setPendingEntities(contextEntityClone);
                    setActiveEntity({...activeEntity, status: foundEntityInResponse.status})
                } else {
                    let newActiveEntity = {...activeEntity, status: foundEntityInResponse.status}
                    setActiveEntity(newActiveEntity);
                }
            }
        } catch(err) {
            console.log(err);
        }
    }

    const fetchEntities = async(scrollAfterDeleting, updating) => {
        try {
            !entitiesLoading && !updating && setEntitiesLoading(true);
            let entitiesData = await getEntities(true);
            if(Array.isArray(entitiesData.content.result) && entitiesData.content.result.length === 0) {
                history.push('/add-entity');
                return;
            }
            entitiesData.content.result.forEach(item => item.color = getRandomColor());
            entitiesData.content.result.sort((a, b) => (a.title && b.title) && a.title.localeCompare(b.title));
            setFullEntitiesList(entitiesData.content.result);
            if(activeIdFromUrl && !scrollAfterDeleting) {
                let foundEntity = entitiesData.content.result.find(item => item.id === parseInt(activeIdFromUrl));
                if(foundEntity) {
                    setActiveEntity(foundEntity);
                } else {
                    history.push('/');
                }
            } else if(activeEntity && !scrollAfterDeleting) {
                let foundEntity = entitiesData.content.result.find(item => item.id === activeEntity.id);
                foundEntity && setActiveEntity(foundEntity);
            } else {
                let foundEntity = entitiesData.content.result[0];
                let scrollElement = (foundEntity && scrollAfterDeleting) ? document.getElementById('entity-' + foundEntity.id) : null;
                scrollElement && scrollElement.scrollIntoView(true);
                foundEntity && scrollAfterDeleting && setUrlEntityScrolledTo(true);
                setActiveEntity(foundEntity);
            }
            setInitialEntityCheck(false);
            setEntitiesLoading(false);
        } catch(err) {
            handleErrors(err);
            setEntitiesLoading(false);
        }
    };

    if(initialEntityCheck) return (
        <div className="container_fullsize-centered">
            <Loader/>
        </div>
    );
    return (
        <div className="d-flex align-items-center h-100 flex-grow-1">
            <div className="home-page__container">
                <div className="home-page__body">
                    <div className="home-page__left">
                        <div className="full-page-wrapper">
                            <EntitiesList
                                entitiesList={fullEntitiesList}
                                entitiesLoading={entitiesLoading}
                                setActiveView={setActiveView}
                                activeView={activeView}
                                refreshEntities={fetchEntities}
                                auth={auth}
                                scrollRef={scrollRef}
                            />
                        </div>
                    </div>
                    <div className={`home-page__center ${activeView === 'entities' ? 'home-page__center--full' : ''}`}>
                        <div className="full-page-wrapper">
                            <EntityView
                                entitiesList={fullEntitiesList}
                                entitiesLoading={entitiesLoading}
                                entityNews={entityNews}
                                auth={auth}
                                setEntityNews={setEntityNews}
                                refreshEntities={fetchEntities}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(Entities);